import React, { useEffect, useContext } from "react";
import userContext from "../../context/users/UserContext";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { breadCrumbItems } from "./Helper";
import Firm2FirmList from "./Firm2FirmList";

const Firm2FirmDashboard = () => {
  const { roles, loadByUsername, authenticated } = useContext(userContext);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
      return;
    }
  }, [authenticated]);

  return (
    <>
      {roles?.length > 0 && (
        <div className="main-container-body">
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div>
          <div
            style={{
              boxSizing: "border-box",
              height: "calc(100% - 59px)",
            }}
          >
            <Firm2FirmList />
          </div>
        </div>
      )}
    </>
  );
};

export default Firm2FirmDashboard;
